import { StylesBuilder } from './StylesBuilder'
import { SectionBuilder } from './SectionBuilder'
import { ComponentBuilder } from './ComponentBuilder'
export class PageBuilder {
  constructor(page) {
    this.page = page
    window.StylesBuilder = new StylesBuilder
  }

  build() {
    this.components = this.page.components.map(component => new ComponentBuilder(component).build())
    this.sections = this.page.sections.map(section => new SectionBuilder(section).build())

    window.StylesBuilder.addStylesString(this.page.styles)
    this.styles = window.StylesBuilder.build()
    this.html = this.buildHtml()
    console.log({ styles: this.styles, html: this.html})
    return {
      styles: this.styles,
      html: this.html
    }
  }

  buildHtml() {
    return `<div>
      ${this.sections}
      ${this.components}
    </div>`
  }
}
